export const injectSEO = () => {
  document.title = "Nismay Studios";
  
  const metaTags = [
    { name: "description", content: "Nismay Studios is a creative development studio based in Gulbarga founded by Mayur Dammannanavar. Specializing in AI tools, healthcare tech, and vibe coding full-stack apps." },
    { name: "keywords", content: "Nismay Studios, Mayur Dammannanavar, NismayCare, Developer Bengaluru, Vibe Coding, React Developer, AI integration" },
    { property: "og:title", content: "Nismay Studios | Mayur Dammannanavar" },
    { property: "og:description", content: "We build bold things. Healthcare tech, AI tools, and sleek full-stack platforms from Gulbarga." },
    { property: "og:type", content: "website" },
    { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" }
  ];

  metaTags.forEach(tag => {
    const attr = tag.name ? `name="${tag.name}"` : `property="${tag.property}"`;
    let el = document.querySelector(`meta[${attr}]`);
    if (!el) {
      el = document.createElement('meta');
      if (tag.name) el.name = tag.name;
      if (tag.property) el.setAttribute('property', tag.property);
      document.head.appendChild(el);
    }
    el.content = tag.content;
  });

  let script = document.querySelector('script[type="application/ld+json"]');
  if (!script) {
    script = document.createElement('script');
    script.type = "application/ld+json";
    const schema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Nismay Studios",
      "founder": {
        "@type": "Person",
        "name": "Mayur Dammannanavar"
      },
      "url": window.location.href,
      "description": "Creative studio building bold software, AI tools, and healthcare systems.",
      "sameAs": [
        "https://github.com/imnismay",
        "https://instagram.com/imnismay"
      ]
    };
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  }
};

export const preventDevTools = () => {
  const handleContextMenu = (e) => e.preventDefault();
  const handleKeyDown = (e) => {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i")) ||
      (e.ctrlKey && e.shiftKey && (e.key === "J" || e.key === "j")) ||
      (e.ctrlKey && e.shiftKey && (e.key === "C" || e.key === "c")) ||
      (e.ctrlKey && (e.key === "U" || e.key === "u"))
    ) {
      e.preventDefault();
    }
  };

  document.addEventListener("contextmenu", handleContextMenu);
  document.addEventListener("keydown", handleKeyDown);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
    document.removeEventListener("keydown", handleKeyDown);
  };
};